/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames/bind.js';
import proptypes from 'prop-types';
const { string, oneOf } = proptypes;
import { Heading } from '@thd-olt-component-react/core-ui';

import styles from './Title.module.scss';

const cx = classNames.bind(styles);

export const Title = ({
  step = '',
  title,
  className = '',
  level = '2'
}) => {
  const isInspirationTitle = className === 'inspiration';

  return (
    <Heading
      className={cx('title', { isInspirationTitle: className })}
      data-testid="title-top"
      level={level}
    >
      <div data-bugbear-id={`${step.replace(' ', '')}Title`}>
        { step && <span data-testid="title-step" className={cx('titleStep')}>{step} </span> }
        { title && <span data-testid="title-main" className={isInspirationTitle ? cx(className) : null}>{title}</span> }
      </div>
    </Heading>
  );
};

Title.propTypes = {
  title: string.isRequired,
  step: string,
  className: string,
  level: oneOf(['1', '2', '3', '4', '5', '6'])
};